export default {
  "Movements queue":"Cua de moviments",
  "Language":"Idioma",
  "Updated successfully":"Actualitzat amb èxit",
  "User Settings":"Configuració de l'usuari",
  "Exit":"Sortir",
  "Warehouse":"Magatzem",
  "Movements history":"Historial de moviments",
  "Stock":"Inventari",
  "Masters":"Mestres",
  "Machines":"Màquines",
  "Positions":"Posicions",
  "Containers":"Contenidors",
  "Families":"Families",
  "Users":"Usuaris",
  "Admin setings":"Configuració d'administrador",
  "Params":"Paràmetres",
  "Logs":"Registres",
  "App settings":"Configuració de l'aplicació",
  "Waiting":"Esperant",
  "Working":"Treballant",
  "Communication lost":"Comunicació perduda",
  "Without communication":"Sense comunicació",
  "Name":"Nom",
  "User name":"Nom d'usuari",
  "Required":"Requerit",
  "Old password":"Contrasenya antiga",
  "New password":"Nova contrasenya",
  "The passwords not match":"Les contrasenyes no coincideixen",
  "Repeat password":"Repetir contrasenya",
  "Dark theme":"Tema fosc",
  "Setings":"Ajustos",
  "Are you sure you want to delete machine %s ?":"Are you sure you want to delete machine {machine} ?",
  "family added succefully":"família afegida amb èxit",
  "family updated succefully":"família actualitzada amb èxit",
  "family":"ID de Família",
  "actions":"Accións",
  "Machines":"Màquines",
  "type":"tipus",
  "Abbreviaton":"Abreviatura",
  "Priority":"Prioritat",
  "Search":"Cerca",
  "containersType":"Tipus de pallet",
  "containerNumber":"Numero de pallet",
  "width":"Ample",
  "height":"Alt",
  "large":"llarg",
  "ID":"ID",
  "PosX":"Posició X",
  "PosY":"Posició Y",
  "PosZ":"Posició Z",
  "maxDepth":"Profunditat Maxima",
  "PositionType":"Tipus Posició",
  "physicalPositions":"Posicions físiques",
  "tracks":"Pistes",
  "originId":"ID de l'origen",
  "destinationId":"ID de destinació",
  "destinationMachine": "Maquina de destinació",
  "positionId":"ID de la posició",
  "New track":"Pista nova",
  "Edit track":"Edita la pista",
  "Add new position":"Afegeix una posició nova",
  "Minimum 2 characters to trigger filtering":"Mínim 2 caràcters per activar el filtratge",
  "New family":"Nova Familia",
  "Edit family":"Edició de Familia",
  "Save":"Guarda",
  "Update":"Actualitza",
  "New machine":"Màquina nova",
  "Edit machine":"Edita la màquina",
  "skuFamilyId":"Identificador de UMS",
  "skuFamilyDescription":"Descripció de UMS",
  "MachineType":"Tipus de Maquina",
  "RotationZone":"Categoria ABC",
  "Created":"Creat",
  "RotationZones":"Categories ABC",
  "RotationZoneId":"Identificador de categoria ABC",
  "DangerIndicators":"Indicadors de perill",
  "ID":"Identificador",
  "Edit dangerIndicator":"Edita l'indicador de perill",
  "New dangerIndicator":"Nou indicador de perill",
  "Danger Indicator deleted successfully":"Indicador de perill eliminat amb èxit",
  "Are you sure you want to delete DangerIndicator %s ?":"Esteu segur que voleu eliminar l'indicador de perill {dangerIndicator}?",
  "Delete danger indicator":"Eliminar indicador de perill",
  "Delete family":"Eliminar família",
  "Are you sure you want to delete family %s ?":"Esteu segur que voleu eliminar la família {family}?",
  "rotationZone delete successfully":"S'ha suprimit la categoria ABC correctament",
  "Danger indicator added succefully":"Indicador de perill afegit correctament",
  "rotationZone updated succesfully":"Categoria ABC actualitzada satisfactòriament",
  "rotationZone delete successfully":"Categoria ABC eliminada correctament",
  "Delete rotationZone":"Esborrar la categoria ABC",
  "Are you sure you want to delete rotationZone %s ?":"¿Està segur que desitja eliminar la categoria ABC {rotationZone}?",
  "Are you sure you want to delete machine %s ?":"¿voleu suprimir la màquina {machineName}?",
  "Machine added succefully":"Màquina afegida amb èxit",
  "Machine updated succefully":"Màquina actualitzada correctament",
  "Machine delete successfully":"La supressió de la màquina s'ha realitzat correctament",
  "Delete machine":"Esborrar maquina",
  "stock":"Inventari",
  "palletId":"Identificador de palet",
  "physicalPositionId":"Identificador de posició fisica",
  "cmPosition":"Posició del CM",
  "batchControl":"Control de lot",
  "clientCode":"Codi del client",
  "expireControl":"Control de caducitat",
  "minimumUsefulLife":"Vida útil mínima",
  "quarentineTime":"Temps de quarantena",
  "rawMaterial":"Matèria primera",
  "rawWeight":"Pes brut",
  "serialControl":"Control de sèrie",
  "skuDescription":"Descripció del SKU",
  "skuId":"ID del SKU",
  "skuShortDescription":"Descripció curta del SKU",
  "stackable":"Apilable",
  "totalUsefulLife":"Vida útil total",
  "weightControl":"Control de pes",
  "containerType":"ID del tipus de pallet",
  "dangerIndicator":"ID de l'indicador de perill",
  "familyId":"ID de família",
  "managedMethodId":"ID del mètode de gestió",
  "measurementUnit":"ID de la unitat de mesura",
  "minimumUsefulLifeTimeMeasurement":"ID de les mesures del temps de vida útil mínima",
  "quarentineTimeMeasurement":"ID de les mesures del temps de quarantena",
  "rotationZone":"ID de la categoria ABC",
  "totalUsefulLifeTimeMeasurement":"ID de les mesures del temps de vida útil total",
  "machineId":"ID de la màquina",
  "items":"Articles",
  "New item":"element nou",
  "Edit item":"Edita l'element",
  "updated":"Actualizat",
  "intermediateId":"ID intermedi",
  "currentPositionId":"ID posició actual",
  "taskId":"ID de tasca",
  "movementType":"Tipus de movimient",
  "status":"Estat",
  "INBOUND":"Entrada",
  "OUTBOUND":"Sortida",
  "RELOCATION":"Reubicació",
  "RETURN_HOME":"Retorn a casa",
  "PICKING":"Picking",
  "Inbound":"Entrada",
  "Outbound":"Sortida",
  "Relocation":"Reubicació",
  "noDataAvailable":"No hi ha dades disponibles",
  "palletNumber":"Quantitat de pallets",
  "skuUnits":"Unitats de sku",
  "expireDate":"Data de caducitat",
  "send":"Enviar",
  "add":"Afegir",
  "Add at least one item in the list":"Afegiu almenys un element a la llista",
  "errorType":"Tipus d'error",
  "deleted":"Eliminat",
  "RESTING":"En repòs",
  "WAITING":"Esperant",
  "SENT":"SENT",
  "SUCCESS":"Èxit",
  "PENDING":"Pendent",
  "PROCESSING": "En procés",
  "ERROR":"Error",
  "COMPLETED":"Completat",
  "COMPLETED_MANUALLY":"Completat manualment",
  "COMPLETED_WITH_ERRORS":"Completat amb errors",
  "CANCELED":"Cancel·lat",
  "REJECTED":"Rebutjat",
  "close":"Tancar",
  "Please enter a expire date":"Introduïu una data de caducitat",
  "noResults":"Sense resultats",
  "searchType":"Typus de cerca",
  "unitsRequested":"Unitats sol·licitades",
  "pickingZone":"Zona de picking",
  "high":"Alta",
  "medium":"Mitjana",
  "low":"Baixa",
  "Please input the pallet ID":"Si us plau, introdueixi l'ID del palet",
  "Please input pallet number":"Si us plau, introdueixi el número de palets",
  "Please select a pallet type":"Si us plau, seleccioni un tipus de palet",
  "Please enter units":"Si us plau, introdueixi les unitats",
  "Please select a search type":"Si us plau, seleccioni el tipus de cerca",
  "Please select a SKU":"Si us plau, selecioni un SKU",
  "Please select a position":"Si us plau, seleccioni una posicio",
  "Please select a position":"Si us plau, seleccioni una maquina",
  "delete":"Eliminar",
  "Enter the destination location where you want to place this pallet":"Introduïu la ubicació de destinació on voleu col·locar aquest palet",
  "Delete movement":"Delete movement",
  "Are you sure you want to delete movement with palleId %s?":"Estàs segur que vols eliminar el moviment amb palletId {palletId}?",
  "Are you sure you want to finish movement with palleId %s?":"Estàs segur que vols finalitzar el moviment amb palletId {palletId}?",
  "The movement will be deleted":"El moviment serà eliminat i el palet romandrà en la seva posició original. Si es tracta d'un moviment d'entrada, el palet no s'emmagatzemarà al magatzem.",
  "The movement will be completed":"El moviment es completarà a la posició de destinació. Si es tracta d'un moviment de sortida, el palet serà eliminat del magatzem.",
  "inboundLock":"",
  "exitLock":"",
  "fullLock":"",
  "totalQuantity":"Quantitat total",
  "warehouseZone":"Zona de magatzem",
  "Item added succefully":"Article afegit correctament",
  "Item updated succefully":"Article actualitzat correctament",
  "Edit physicalPosition":"Edita la posició física",
  "inboundLock":"Bloqueig d'entrada",
  "exitLock":"Bloqueig de sortida",
  "fullLock":"Bloqueig complet",
  "ExploitationCenter":"Centre d'explotació",
  "LocationType":"Tipus de localització",
  "AisleNumber":"Número de passadís",
  "Laterality":"Lateralitat",
  "BayNumber":"Número de moll",
  "LevelNumber":"Número de nivell",
  "LocationCode":"Codi de localització",
  "InUse":"En ús",
  "ReservedEntrance":"Entrada reservada",
  "ReservedExit":"Sortida reservada",
  "Side":"Costat",
  "Bay":"Moll",
  "Level":"Nivell",
  "Position":"Posició",
  "alternativeId":"Id alternativa",
  "generalLock":"Bloqueig general",
  "inbound":"Entrada",
  "outbound":"Sortida",
  "relocation":"Reubicació",
  "picking":"Picking",
  "HUBMASTER - Location catalog":"HUBMASTER - Catàleg de localitzacions",
  "Select the block to apply in the location":"Seleccioneu el bloc a aplicar a la ubicació",
  "Indicate the reason for blocking the location":"Indiqueu el motiu per bloquejar la ubicació",
  "dateRange":"Interval de dates",
  "depth":"Profunditat",
  "moreInfo":"Més informació",
  "quantity":"Quantitat",
  "superAdminLock":"Bloqueig de super administrador",
  "atHome":"En repòs",
  "itemId":"ID de l'article",
  "managementMethod":"Mètode de gestió",
  "totalUsefulLifeTimeMeasurement":"Mesura de la vida útil total",
  "requiredfield":"Camp requerit",
  "visibleComlumns":"Columnes visibles",
  "frontOverhang":"Voladís davanter",
  "backOverhang":"Voladís posterior",
  "rejectReasonCode":"Codi de motiu de rebuig",
  "monday":"Dilluns",
  "tuesday":"Dimarts",
  "wednesday":"Dimecres",
  "thursday":"Dijous",
  "friday":"Divendres",
  "saturday":"Dissabte",
  "sunday":"Diumenge",
  "stockExcel":"Inventory Alignment",
  "compactionHm1":"Compactació HM1",
  "compactionHm2":"Compactació HM2",
  "compactionHm3":"Compactació HM3",
  "rotationZoneAssignment":"Asignació de zona de rotació",
  "photostock":"Photostock",
  "tasks":"Tasques",
  "update":"Actualitzar",
  "disabled":"Deshabilitat",
  "enabled":"Habilitat",
  "taskLog":"Registre de tasques",
  "taskName":"Nom de la tasca",
  "stop":"Atura",
  "finished":"Acabat",
  "working":"Treballant",
  "Lock position updated succefully":"Posició de bloqueig actualitzada correctament",
  "Reason is required":"Es requereix un motiu",
  "Alarms":"Alarmes",
  "alarmId":"Id de l'alarma",
  "alarmStatus":"Estat de l'alarma",
  "alarmName":"Nom de l'alarma",
  "problemDescription":"Descripció del problema",
  "created":"Creat",
  "deleted":"Eliminat",
  "Alarm Update Succesfully":"Alarma actualizada correctamente",
  "Active":"Actiu",
  "Solved":"Resolts",
  "block":"bloc",
  "blockPositionType":"tipus de posició de bloc",
  "stockRemove":"Eliminar confirmació",
  "You confirm that pallet with ID {palletId} is no longer in location {physicalPositionId}?":"Confirma que el palet amb ID {palletId} ja no està a la ubicació {physicalPositionId}?",
  "serverTime":"Data hora local del servidor",
  "alternativeId":"Id alternativa",
  "Select Positions":"Seleccionar posicions",
  "Block Positions":"Bloquejar",
  "Unblock Positions":"Desbloquejar",
  "Select Positions":"Select Positions",
  "Block Positions":"Block Positions",
  "Unblock Positions":"Unblock Positions",
  "Selected Positions:":"Selected Positions:",
  "Select Block Type":"Select Block Type",
  "Please provide necessary data":"Proporcioneu la informació necesaria",
  "Cancel":"Cancel·lar",
  "Are you sure you want to unblock the following positions?":"Esteu segur que voleu desbloquejar les següents posicions?",
  "Positions blocked successfully":"Posicions bloquejades correctament",
  "Error blocking positions":"Error en bloquejar les posicions",
  "Positions unblocked successfully":"Posicions desbloquejades correctament",
  "Error unblocking positions":"Error en desbloquejar les posicions",
  "Blocked Positions":"Posicions bloquejades",
  "Unlocked positions":"Posicions desbloquejades",
  "All positions":"Totes les posicions",
  "Lock removed successfully":"Bloqueig eliminat correctament",
  "kpisDashboard":"Pissarra de kpi",
  "Total Inbounds Today":"Total d'entrades avui",
  "Total Outbounds Today":"Total de sortides avui",
  "Error Types":"Tipus d'errors",
  "Total Errors in Inbounds and Outbounds Today":"Total d'errors en entrades i sortides avui",
  "Kpi's Dashboard":"Pissarra de kpi",
  "Dashboard":"Marc",
  "totalMovements":"Total Moviments",
  "movementsPerHour":"Moviments per Hora",
  "movementsPerDay":"Moviments per Dia",
  "averageMovementTime":"Temps Mitja de Moviment",
  "movementsByType":"Moviments per Tipus",
  "movementsByMachine":"Moviments per Maquina",
  "movementsByZone":"Moviments per Zona",
  "inboundMovements":"Moviments d'Entrada",
  "outboundMovements":"Moviments de Sortida",
  "internalMovements":"Moviments Interns",
  "rotationMovements":"Moviments de Rotacio",
  "machineEfficiency":"Eficiencia de Maquina",
  "pendingMovements":"Moviments Pendents",
  "completedMovements":"Moviments Completats",
  "inProgressMovements":"Moviments en Progres",
  "cancelledMovements":"Moviments Cancelats",
  "averageCycleTime":"Temps de Cicle Mitja",
  "movementsTrend":"Tendència de Moviments",
  "sinceLastPeriod":"des del periode anterior",
  "pending":"Pendent",
  "completed":"Completat",
  "inProgress":"En Progres",
  "cancelled":"Cancelat",
  "No data available":"Sense dades disponibles",
  "Movements":"Moviments",
  "delete":"Eliminar",
  "edit":"Editar",
  "positionType":"Tipus de posició",
  "out":"Sortida",

  "New Alarm Detected!":"Nova alarma!",
  "Minimize":"Minimitzar",
  "Maximize":"Maximitzar",
  "TOTAL INBOUNDS":"TOTAL D'ENTRADES",
  "Total Inbounds":"Total d'entrades",
  "Today":"Avui",
  "Hours":"Hores",
  "Daily":"Diari",
  "Weekly":"Setmanal",
  "Monthly":"Mensual",
  "Average Inbounds per":"Mitjana d'entrades per",
  "Hour":"Hora",
  "Day":"Dia",
  "Monday":"Dilluns",
  "Tuesday":"Dimarts",
  "Wednesday":"Dimecres",
  "Thursday":"Dijous",
  "Friday":"Divendres",
  "Saturday":"Dissabte",
  "Sunday":"Diumenge",
  "Week":"Setmana",
  "Month":"Mes",
  "Inbounds":"Entrades",
  "Close":"Tancar",
  "alternativeTypeNumber":"ID tipus de pallet WMS",
  "January":"Gener",
  "February":"Febrer",
  "March":"Març",
  "April":"Abril",
  "May":"Maig",
  "June":"Juny",
  "July":"Juliol",
  "August":"Agost",
  "September":"Setembre",
  "October":"Octubre",
  "November":"Novembre",
  "December":"Desembre",
  "Outbounds":"Sortides",
  "TOTAL OUTBOUNDS":"TOTAL DE SORTIDES",
  "Total Outbounds":"Total de sortides",
  "Average Outbounds per":"Mitjana de sortides per",
  "Average Errors per":"Mitjana d'errors per",
  "Priority":"Prioritat",
  "userId":"Id d'usuari",
  "name":"Nom",
  "username":"Nom d'usuari",
  "rol":"Rol",
  "editUser":"Editar usuari",
  "password":"Contrasenya",
  "repeatPassword":"Repetir contrasenya",
  "Are you sure you want to delete {name}?":"Estàs segur que vols eliminar {name}?",
  "deleteUser":"Eliminar usuari",
  "User {name} deleted":"Usuari {name} eliminat",
  "params":"Paràmetres",
  "search":"Cercar",
  "new":"Nou",
  "edit":"Editar",
  "delete":"Eliminar",
  "editParam":"Editar paràmetre",
  "newParam":"Nou paràmetre",
  "key":"Clau",
  "value":"Valor",
  "pleaseEnterKey":"Si us plau, introdueix una clau",
  "pleaseEnterValue":"Si us plau, introdueix un valor",
  "update":"Actualitzar",
  "save":"Desar",
  "actions":"Accions",
  "id":"Id",
  "added":"afegit",
  "successfully":"amb èxit",
  "deleteParam":"Eliminar paràmetre",
  "areYouSureDeleteParam":"Estàs segur que vols eliminar el paràmetre {key}?",
  "deletedSuccessfully":"eliminat amb èxit",
  "logger":"Registre",
  "close":"Tancar",
  "search":"Cercar",
  "user":"Usuari",
  "searchByMessage":"Cercar per missatge",
  "dataTime":"Data i hora",
  "level":"Nivell",
  "message":"Missatge",
  "installationName":"Nom de la instal·lació",
  "hmWareUrl":"URL de Hmware",
  "cmLogicUrl":"URL de Cmlogic",
  "cmLogicUser":"Usuari de Cmlogic",
  "cmLogicPassword":"Contrasenya de Cmlogic",
  "wmsUrl":"URL de WMS",
  "wmsUser":"Usuari de WMS",
  "wmsPassword":"Contrasenya de WMS",
  "imagesPath":"Ruta d'imatges",
  "analyticsUrl":"URL d'anàlisis",
  "update":"Actualitzar",
  "required":"Requerit",
  "updatedSuccessfully":"Actualitzat correctament",
  "Total Errors":"Total d'errors",
  "Errors Type":"Tipus d'errors",
  "Errors":"Errors",
  "Warehouse Occupancy":"Ocupació del magatzem",
  "Free":"Lliure",
  "Occupied":"Ocupat",
  "Occupied positions":"posicions ocupades",
  "completed":"Completat",
  "takeOutStock":"Retirar estoc",
  "No data available today":"No hi ha dades disponibles avui",
  "Average Activity":"Activitat mitjana",
  "Average Real-Time Activity per Machine":"Activitat mitjana en temps real per màquina",
  "Activity":"Activitat",
  "inqueue":"Aquest pallet possiblement és a la cua de moviments",
  "batchNumber":"Número de lot",
  "warehouseViewer":"Visor de magatzem",
  "priority":"Prioritat",
  "removalEmptyPallets":"Extracció de pallets vuits",
  "newUser":"Nou usuari",
  "Select Block Depth":"Seleccionar Profunditat de Bloc",
  "Only depth 2":"Només la segona profunditat",
  "All depths":"Totes les profunditats",
  "Some positions were excluded as they do not have Second Depth":"Algunes posicions han quedat excloses perquè no tenen Segona Profunditat",
  "Please input pallet weight":"Introdueix el pes de la paleta",
  "Please input pallet height":"Introdueix la altura de la paleta",
  "allowedItems":"Articles permesos",
  "legendEmpty":"Posició lliure",
  "legendFull":"Posició ocupada",
  "legendEmptyLocked":"Posició lliure bloquejada",
  "legendFullLocked":"Posició ocupada bloquejada",
  "legendInstructions":"Per veure els detalls d'una posició a la imatge, col·loca el cursor sobre ella i fes doble clic. Si vols girar la imatge, fes clic amb el botó esquerre i arrossega el ratolí en la direcció desitjada. Per moure la imatge, mantén premut el botó dret del ratolí mentre mous el cursor.",
  "visibleLabels":"Etiquetes de les badies visibles",
  "inventoryBalance":"Balanç d' inventari",
  "Free positions":"Posicions lliures",
  "stockAdjustment":"Ajust d'estoc",
  "runNow":"Executar ara",
  "serialNumber":"Número de serie",
  "families":"Families",
  "nextStep":"Següent pas",
  "You confirm that current step is complete and run next step: {palletId}?":"Confirmes que el pas actual està complet i vols continuar amb el següent pas: {palletId}?",
  "download":"Descarregar",
  "pause":"Pausa",
  "cameras": "Càmeres",
  "inventoryProcess": "Procés d'inventari",
  "inventoryRequest": "Sol·licitud d'inventari",
  "inventoryType": "Tipus d'inventari",
  "photo_counting": "Recompte de fotos",
  "inventory_counting": "Recompte d'inventari",
  "viewPhoto": "Veure foto",
  "pending_return": "Pendent de devolució",
  "You confirm that the following pallet doesn't exist: {palletId}?":"Confirmes que el següent palet no existeix: {palletId}?",
  "inventory":"Inventari",
  "showLive": "Mostrar en directe",
  "AVERAGE INBOUNDS PER HOUR":"PROMIG D'ENTRADES PER HORA",
  "Average Inbounds per Hour":"Entrades per hora",
  "Error fetching data":"Error obtenint les dades",
  "Average":"Promig",
  "AVERAGE OUTBOUNDS PER HOUR":"PROMIG D' SORTIDES PER HORA",
  "Average Outbounds per Hour":"Promig d'sortides per hora",
  "Average Outbounds":"Promig d'sortides",
  "TOTAL NUMBER OF REJECTED PALLETS": "NOMBRE TOTAL DE PALETS REBUTJATS",
  "Pallets Rejected": "Palets Rebutjats",
  "Total Number of Rejected": "Nombre Total de Rebutjats",
  "since last month":"des de l'últim mes",
  "palletHeight": "Alçada del palet",
  "palletWidth": "Amplada del palet",
  "palletWeight": "Pes del palet",
  "palletDepth": "Profunditat del palet",
  "machine": "Màquina",
  "valueMustBeGreaterAndLessThan": "El valor ha de ser major que {min} i menor que {max}",
  "nextStep": "Següent pas",
  "You confirm that current step is complete and run next step: {palletId}?": "Confirmes que el pas actual està complet i vols continuar amb el següent pas: {palletId}?",
  "download": "Descarregar",
  "PAUSE": "Pausa",
  "movSubType": "Subtipus de moviment",
  "CANCELED": "Cancel·lat",
  "SUSPENDED": "Suspes",
  "PICK_STATION": "Recollida a l'estació",
  "PICK_RACK":"Recollida al rack",
  "DROP_STATION":"Deixar a la estació",
  "DROP_RACK":"Deixar al rack",
  "INVENTORY":"Inventari",
  "DROP_GRAVITY_OUT":"Deixar a la sortida per gravetat",
  "CONVEYOR":"Conveyor",
  "SHUTTLE":"Shuttle",
  "CONVEYOR_DS":"Conveyor DS",
  "Are you sure the pallet is there?" : "Esteu segur que el palet està allà?",
  "conveyor side": "Costat del conveyor",
  "systemSelected": "Sistema seleccionat",
  "system1": "Sistema 1",
  "system2": "Sistema 2",
  "system3": "Sistema 3",
  "cancelInventoryProcess": "Cancel·lar procés d'inventari",
  "areYouSureInventoryProcess": "Are you sure you want to cancel the inventory process?",
  "inventoryProcessCanceled": "Procés d'inventari cancel·lat",
  "TotalInboundsMoreInfo":"Mostra el nombre total d'entrades de mercaderies registrades al magatzem durant el període seleccionat. La fletxa mostra la tendència respecte al període anterior.",
  "TotalOutboundsMoreInfo":"Mostra el nombre total de sortides de mercaderies registrades al magatzem durant el període seleccionat. La fletxa mostra la tendència respecte al període anterior.",
  "TotalErrorsMoreInfo":"Mostra el nombre total d'errors registrats durant les operacions d'entrada i sortida de mercaderies al magatzem durant el període seleccionat. La fletxa mostra la tendència respecte al període anterior.",
  "ErrorsTypeMoreInfo":"Aquest gràfic de donut desglossa el total d'errors per categoria o tipus, permetent identificar ràpidament les causes més comunes de fallades operatives.",
  "RejectReasonsMoreInfo":"Aquest gràfic de donut mostra les raons per les quals els articles van ser rebutjats durant les operacions d'entrada o sortida, ajudant a identificar patrons i millorar la qualitat del procés.",
  "WarehouseOccupancyMoreInfo":"Mostra el percentatge d'espai d'emmagatzematge que està actualment en ús. El gràfic de donut visualitza la proporció entre l'espai ocupat i el lliure.",
  "AverageActivityMoreInfo":"Mostra l'activitat promig de les màquines al magatzem durant el període seleccionat. La fletxa indica la tendència respecte al període anterior.",
  "TotalOccupancyMoreInfo":"Mostra el percentatge d'ocupació del magatzem durant el període seleccionat. La fletxa mostra la tendència respecte al període anterior.",
  "delete movement":"Eliminar moviment",
  "Confirm and place pallet":"Confirmar i col·locar palet",
  "Running": "En execució",
  "Finish movement":"Finalitzar moviment",
  "Confirm all active alarms": "Confirmar totes les alarmes actives",
  "videos": "Vídeos",
  "Terminal":"Terminal",
  "noMatchesFound": "No s'han trobat coincidències",
  "Confirm":"Confirmar",
  "Are you sure you want to confirm all active alarms? This action cannot be undone.": "Esteu segur que voleu confirmar totes les alarmes actives?",
  "All active alarms confirmed successfully.": "Alarmes confirmades amb èxit",
  "No active alarms to confirm.": "No hi ha alarmes actives per confirmar",
  "charts": "Gràfiques",
  "outbound": "sortida",
  "inbound": "entrada",
  "lock": "bloquejar",
  "lock_reason": "motiu del bloqueig",
  "unlock": "desbloquejar",
  "yes": "sí",
  "no": "no",
  "cancel": "cancel·lar",
  "help": "ajuda",
  "occupation": "ocupació",
  "All": "Tots",
  "today": "Avui",
  "last7days": "Últims 7 dies",
  "last30days": "Últims 30 dies",
  "Close": "Tancar",
  "accessDenied": "No té permís per accedir a aquesta pàgina. Si us plau, contacti amb el seu administrador.",
  "systemLogs": "Logs del sistema",
  "logFile": "Arxiu de log",
  "fromDate": "Des de data",
  "toDate": "Fins data",
  "searchInTrace": "Buscar en trace",
  "dateTime": "Data",
  "logType": "Tipus",
  "class": "Classe",
  "trace": "Traça",
  "refresh": "Actualitzar",
  "typeFilter": "Filtrar per tipus",
  "Movement Time (Minutes)": "Temps de Moviment (Minuts)",
  "Days": "Dies",
  "Weeks": "Setmanes",
  "Average Movement Time": "Temps Mitjà de Moviment",
  "Day": "Dia",
  "Week": "Setmana",
  "Capacity per Hour": "Capacitat per hora",
  "Movements per Hour": "Moviments per hora",
  "All Movements": "Tots els moviments",
  "No results": "Sense resultats",
  "Outlier": "Outlier",
  "Movement Type": "Tipus de moviment",
  "Process duration": "Durada del procés",
  "Status": "Estat",
  "per Machine": "per Màquina",
  "Avg Movement Duration Trend": "Tendència de durada mitjana de moviment",
  "Registered movements": "Moviments registrats",
  "Picking": "Picking",
  "An unexpected error occurred": "Ha ocorregut un error inesperat",
  "Error loading data": "Error en carregar les dades",
  "Minutes": "Minuts",
  "Total Errors": "Total d'errors",
  "Reject Reasons": "Motius de rebuig",
  "Average Real-Time Activity": "Activitat mitjana en temps real",
  "uptimeKpi":"Temps d'activitat KPI",
  "capacityDashboard":"Capacitat del magatzem",
  "maintenanceResponse":"Resposta de manteniment",
  "primaryKpi":"KPI primari",
  "totalTime":"Temps total",
  "stoppedTime":"Temps aturat",
  "detailedAnalysisBySystem":"Anàlisi detallada per sistema",
  "HourlyViewSingleDaySelected":"Vista horaria - Un dia seleccionat",
  "DailyViewMultipleDaysSelected":"Vista diaria - Múltiples dies seleccionats",
  "FaultTime":"Temps en fallada",
  "uptime":"Temps d'activitat",
  "FaultTime":"Fault time",
  "AcknowledgmentTime":"Temps de reconeixement",
  "RepairTime":"Temps de reparació",
  "ResolutionTime":"Temps de resolució",
  "Fault occurrence time → Maintenance acknowledgment time":"Temps d'error → Temps de reconeixement",
  "Maintenaance acknowledgment time → Maintenance resolution time":"Temps de reconeixement → Temps de resolució",
  "Fault occurrence time → Maintenance resolution time":"Temps d'error → Temps de resolució",
  "avg":"Promig",
  "minimum":"Mínim",
  "maximum":"Màxim",
  "DowntimeAndErrorsPerDay":"Temps d'inactivitat i errors per dia",
  "DowntimeAndErrorCountPerDay":"Temps d'inactivitat i comptador d'errors per dia",
  "DowntimeAndErrorCountPerHour":"Temps d'inactivitat i comptador d'errors per hora",
  "downtime":"Temps d'inactivitat",
  "errorCount":"Comptador d'errors",
  "AverageEvolutionOfResponseTime":"Evolució mitjana del temps de resposta",
  "TrendInMaintenanceTimes":"Tendència en temps de manteniment",
  "acknowledgmentTime":"Temps de reconeixement",
  "resolutionTime":"Temps de resolució",
  "ErrorBreakdown":"Desglossament d'errors",
  "DetailedHistoryOfFailuresAndResponseTimes":"Historial detallat d'errors i temps de resposta",
  "system":"Sistema",
  "occurrence":"Ocurrència",
  "repairTime":"Temps de reparació",
  "reactionTime":"Temps de reacció",
  "time":"Temps",
  "resolved":"Resolt",
  "TotalErrors":"Total d'errors",
  "InSelectedPeriod":"En el període seleccionat, la suma de errors de tots els sistemes",
  "TotalDowntime":"Temps total en fallada",
  "HourlyAverage":"Promig horari",
  "DailyAverage":"Promig diari",
  "ErrorsPerHour":"Errors per hora de tots els sistemes",
  "ErrorsPerDay":"Errors per dia de tots els sistemes",
  "Change password on next login":"Canvia la contrasenya al següent login",
  "activeTasks":"Tasques actives",
  "An unexpected error occurred":"S'ha produït un error inesperat",
  "recoveryTime":"Temps de recuperació",
  "cumulativeTotal":"Total acumulat",
  "Total downtime":"Temps total en fallada",
  "Maintenance response time":"Temps de resposta de manteniment",
  "Maintenance acknowledgment time → Maintenance arrival time":"Temps de reconeixement → Temps d'arribada",
  "Maintenance arrival time → Maintenance resolution time":"Temps d'arribada → Temps de resolució",
  "notResolved":"No resolt",
  "maxDaysMachineStopped":"{days} dies des de que les màquines estan aturades",
  "SumOfTheTimeOfAllSystems":"Sum of the time of all systems",
  "Pallet Type / Height":"Pallet Type / Height",
  "movementsKpi":"Duració de moviments",
  "Registered movements":"Moviments registrats",
  "Error loading data":"Error en carregar les dades",
  "Avg Movement Duration Trend":"Tendència de durada mitjana de moviments",
  "Days":"Dies",
  "Weeks":"Setmanes",
  "Minutes":"Minuts",
  "Generate inbound":"Generar entrada",
  "Generate outbound":"Generar sortida",
  "numberOfPallets":"Nombre de palets",
  "generate":"Generar",
  "generateInboundDescription":"Genera {count} moviments d'entrada aleatoris per a demo.",
  "generateOutboundDescription":"Genera {count} moviments de sortida aleatoris per a demo. Opcionalment filtrar per SKU.",
  "Height":"Alçada",
  "Total positions":"Total de posicions",
  "positions":"posicions",
  "heightChartTitle":"Alçada {letter} ({height} {unit})",
  "totalPositionsLabel":"Total de posicions:",
	"noFreePositions":"No hi ha posicions lliures",
  "metricSystem": "Sistema mètric",
  "metricSystemIS": "Sistema Internacional (mm, kg)",
  "metricSystemUSCS": "Sistema consuetudinari dels EUA (in, lb)",
  "weight":"Pes",
  "analyticsUser":"Usuari d'Analytics",
  "analyticsPassword":"Contrasenya d'Analytics",
  "localhostIp":"IP de localhost",
  "returnToHomeDelay":"Retard de retorn a origen (segons; 0 = desactivat)",
  "addContainer":"Afegeix contenidor",
  "newInbound":"Nova entrada",
  "newOutbound":"Nova sortida",
  "None":"Cap",
  "ROLE_ADMIN":"Administrador",
  "ROLE_COMMUNICATION":"Comunicació",
  "ROLE_WMS":"WMS",
  "ROLE_SUPERADMIN":"Superadministrador",
  "ROLE_USER":"Usuari",
  "ROLE_ENGINEERING":"Enginyeria",
  "ROLE_MAINTENANCE":"Manteniment",
  "Orders queue":"Cua d'ordres",
  "Orders history":"Historial d'ordres",
  "Pallets measures":"Mesures de palets",
  "PLC params":"Paràmetres PLC",
  "Acquisition (PPA)":"Adquisició de núvol de punts (PPA)",
  "System Logs":"Registres del sistema",
};
